/* Auto Generated */

export enum SwitchStatus {
	switchIsFinal,
	switchIsRequested,
	notSwitched,
}
